import React from 'react';

export default function Footer() {
  return <footer style={{
    borderTop: '1px dashed #666',
    position:'relative',
    padding:15,
    paddingRight:20,
    // backgroundColor:'#0e4a42',
    paddingLeft:20,
    display:'flex',
    flexWrap:'wrap',
    flexDirection:'row'}}>
    <div style={{display:'flex', 
      flex:1, justifyContent:'space-between'}}>
      <p style={{
          fontSize:18, 
          fontWeight:'bold', 
          color:'var(--secondary-text-color)', 
          paddingLeft:10}}>
          © Tudor Barbulescu
      </p>
      <div style={{
        display:'flex', flex:1,
        flexDirection:'column',
        alignItems:'flex-end',
        justifyContent:'flex-end',
        fontSize:'0.9rem'
        }}>
          <p style={{margin:4}}>
            &nbsp;Coffee machine by&nbsp;
            <a 
              target="_blank" 
              href="https://codepen.io/hjdesigner/pen/jvyJdX" 
              rel="noreferrer">
                Henrique Rodrigues
            </a>        
          </p>
          <p style={{margin:4}}>
            &nbsp;Floating shapes by&nbsp;
            <a 
              href="https://www.fdmdigital.co.uk/css-floating-background-shapes/"
              target="_blank"
              rel="noopener noreferrer">
              fdmdigital
            </a>
          </p>
      </div>
    </div>
  </footer>;
}
